import { get, isEmpty } from 'lodash';
import axios from 'axios';
import { internalAxios } from '../../../utils/axios/internal';
import { getSessionStorage } from '../../../utils/storage';

export const LOT_NEXT_PREV_KEY = 'lot-show-next-prev';

export const retrievePrevNext = async ({ idlot }) => {
  if (document.referrer.includes('/myartprice/')) {
    return;
  }

  let prevLot;
  let nextLot;
  let currentLot;
  let params;

  const search = getSessionStorage(LOT_NEXT_PREV_KEY) || {};
  const { page, md5 } = search;
  const items = get(search, `lots[${md5}.items[${page}]`, []);

  if (!isEmpty(items)) {
    items.forEach(item => {
      if (idlot !== item.id && !currentLot) {
        prevLot = item;
      } else if (idlot === item.id) {
        currentLot = item;
      } else if (currentLot && !nextLot) {
        nextLot = item;
      }
    });

    if (!prevLot) {
      if (search.lots[md5].items[page - 1]) {
        prevLot = search.lots[md5].items[page - 1][search.lots[md5].items[page - 1].length - 1];
      } else if (page > 1) {
        try {
          const data = internalAxios.get(search.lots[md5].pathname, { params: { ...search.lots[md5].query, p: page - 1 } });

          search.lots[md5].items[page - 1] = [];
          if (data && data.data && data.data.items) {
            data.data.items.forEach(item => search.lots[md5].items[page - 1].push({ id: item.id, url: item.url, page: page - 1 }));
          }
          prevLot = search.lots[md5].items[page - 1][search.lots[md5].items[page - 1].length - 1];
        } catch (err) {
          if (!axios.isCancel(err)) throw new Error(`Error while getting previous lot : ${search.lots[md5].pathname}.json with params ${JSON.stringify(params)}`);
        }
      }
    }

    if (!nextLot) {
      if (search.lots[md5].items[page + 1]) {
        nextLot = search.lots[md5].items[page + 1][0];
      } else {
        try {
          const data = internalAxios.get(search.lots[md5].pathname, { params: { ...search.lots[md5].query, p: page + 1 } });

          search.lots[md5].items[page + 1] = [];
          if (data && data.data && data.data.items) {
            data.data.items.forEach(item => search.lots[md5].items[page + 1].push({ id: item.id, url: item.url, page: page + 1 }));
          }
          nextLot = search.lots[md5].items[page + 1][0];
        } catch (err) {
          if (!axios.isCancel(err)) throw new Error(`Error while getting previous lot : ${search.lots[md5].pathname}.json with params ${JSON.stringify(params)}`);
        }
      }
    }
  }

  return {
    prevLot,
    nextLot,
  };
};
